var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"boxi"},[_c('div',{class:_vm.type == 'center'
        ? 'd-flex justify-content-center align-items-center'
        : 'd-flex align-items-center on-hover'},[_c('div',[(
          _vm.employee.image_url == '' ||
          _vm.employee.image_url == null ||
          _vm.employee.image_url == undefined
        )?[_c('img',{staticClass:"imgCandidate",attrs:{"src":"/images/user/no-image.png"}})]:[_c('img',{staticClass:"imgCandidate",attrs:{"src":_vm.SERVER_URL + _vm.IMAGES_FILES + _vm.employee.image_url}})]],2),_c('div',{staticClass:"textinBoxCandidateDetails"},[_c('h4',[_vm._v(_vm._s(_vm.employee.name)+" "+_vm._s(_vm.employee.surname))]),_c('h5',[_vm._v(_vm._s(_vm.employee.position))]),_c('h5',[_vm._v(_vm._s(_vm.employee.department))])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }